import { render, staticRenderFns } from "./newCompensate.vue?vue&type=template&id=d0385f04&"
import script from "./newCompensate.vue?vue&type=script&lang=js&"
export * from "./newCompensate.vue?vue&type=script&lang=js&"
import style0 from "./newCompensate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports